import {Component, ChangeDetectorRef, ElementRef, Renderer2, ViewEncapsulation} from '@angular/core';
import { PONodeComponent } from '../abstract-classes/po-node/ponode.component';
import { CategoryNodeComponent } from '../category-node/category-node.component';
import { ArrangementNodeComponent } from '../arrangement-node/arrangement-node.component';
import { ProductNodeComponent } from '../product-node/product-node.component';
import { ProductOverviewService } from '../../../services/product-overview/product-overview.service';
import { DetailScreensService } from '../detail-screens-module/services/detail-screens-service';
import { DomService } from '../../../services/dom-service/dom.service';
import { UiHelperService } from '../../../services/shared/helpers/ui-helper.service';
import { ExpandNodeInfo } from '../../../services/shared/helpers/ui-helper.models';
import {PopupService} from '../popup-component/popup.service/popup.service';
import {ProductOverviewRequest} from '../../../services/product-overview/product-overview-request.model';
import {MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions} from '@angular/material/tooltip';


/** Custom options the configure the tooltip's default show/hide delays. */
export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 1000,
  hideDelay: 1000,
  touchendHideDelay: 1000,
};

@Component({
  selector: 'app-cluster-node',
  templateUrl: './cluster-node.component.html',
  styleUrls: ['./cluster-node.component.css'],
  providers: [
    {provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults},
  ],
})
export class ClusterNodeComponent extends PONodeComponent {

  nodeType = 'cluster-node';
  private expandNodeInfo: ExpandNodeInfo;
  constructor(domService: DomService,
              productOverviewService: ProductOverviewService,
              el: ElementRef,
              renderer: Renderer2,
              changeRef: ChangeDetectorRef,
              detailsScreenService: DetailScreensService,
              private uiHelperService: UiHelperService, popupService: PopupService) {
    super(domService, detailsScreenService, changeRef, el, renderer, productOverviewService, popupService, uiHelperService);
  }
  initializeComponents(): void {
    this.children = [];

    this.expandNodeInfo = this.uiHelperService.expandNode(this, this.hierarchyChildren);
    this.expanded = this.expandNodeInfo.parent_expand || false;

    const children = Array.isArray(this.hierarchyChildren) ? this.hierarchyChildren : [];

    children.forEach((child: any, index: number) => {
      child.expandByProdCluster = false;
      if (this.expandNodeInfo.child_expand === index) {
        child.expandByProdCluster = true;
      }

      this.determineChildComponentType(child, CategoryNodeComponent);

      if (this.childComponentType !== ArrangementNodeComponent) {
        const comp = this.createComponent(child, this.childComponentType);
        if (comp) {
          comp.isLastChild = index === children.length - 1;
          this.children.push(comp); // ✅ Always push
        }
      }
    });

    if (this.listOfArrangementsToCreate.length !== 0) {
      this.createArrangements().forEach((arrangement, index, arrList) => {
        if (arrangement) {
          arrangement.isLastChild = index === arrList.length - 1;
          this.children.push(arrangement); // ✅ Always push
        }
      });
    }

    this.changeRef.detectChanges();

    this.children.forEach((child) => {
      if (
        child.expandable &&
        Array.isArray(child.hierarchyChildren) &&
        child.hierarchyChildren.length > 0 &&
        typeof child.initializeComponents === 'function'
      ) {
        child.initializeComponents(); // ✅ Only call if it exists
      }
    });
  }
  determineChildComponentType(child, defaultComponentType) {
    if (this.childIsArrangement(child)) {
      this.childComponentType = ArrangementNodeComponent;
      this.listOfArrangementsToCreate.push(child);
    } else if (this.childHasArrangements(child)) {
      this.childComponentType = ProductNodeComponent;
    } else {
      this.childComponentType = defaultComponentType;
    }
  }

  loadProductServicesRequiredData() {
    return {
      arrangementNumber: this.data.arrangementNumber,
      administrationCode: this.data.administrationCode,
      commercialProductTypeCode: this.data.commercialProductTypeCode,
      relationRestrictedDataView: true,
      restrictedDataViewException: this.data.restrictedDataViewException,
      relationMarketSegmentCode: this.data.relationMarketSegmentCode,
      parameterToken: ProductOverviewRequest.parametersToken,
      orgYN: ProductOverviewRequest.orgYN,
    };
  }
  public logHoverAmount() {
    // this.uiHelper.logHoverAmount().subscribe((res) => {
    // });
    return this.data.restrictedData;
  }
}
